/*
 * @Author: zhangsusha@58.com
 * @LastEditors: zhangsusha
 * @LastEditTime: 2023-11-21 10:11:02
 * @FilePath: /ershoufang-common-nuxt/store/index.js
 * @Description: zhangsusha
 * @Date: 2023-03-08 14:48:02
 * Copyright (c) 2023 by zhangsusha/五八, All Rights Reserved.
 */
import _ from 'lodash';
import Vue from 'vue';
import { checkWeappByUserAgent, checkMiniProgramByUserAgent, checkToutiaoProgramByUserAgent } from '~/utils/common';
import createModule from '../pages/old/home/store/index';

export const state = () => ({
    feCommon: {},
    request: {}
});

export const mutations = {
    updateFeCommon: (state, data) => {
        state.feCommon = data;
    },
    updateRequest: (state, data) => {
        Vue.set(state, `request`, data);
    }
};

export const getters = {
    getFeCommon: state => {
        return state.feCommon;
    },
    getRequest: state => state.request
};

export const actions = {
    nuxtServerInit: ({ commit }, { req }) => {
        let origin = req.ctx.origin;
        const { 'x-scheme': xScheme, host } = req.headers;
        if (host && xScheme) origin = xScheme + '://' + host;
        commit(
            'updateFeCommon',
            _.merge({}, req.ctx.feCommon, {
                origin,
                host
            })
        );

        const { seo_source_type: seoSourceType, guid, location, app, source_h5: sourceH5, cityV2 } =
            req.ctx.feCommon || {};
        const { 'user-agent': ua } = req.headers;
        console.log(`feCommon--:`, req.ctx.feCommon);
        const appValue = _.get(app, 'value');
        const appType = _.get(app, 'type');
        let isFromApp = '';
        switch (appType) {
            case 'miniprogram':
            case 'weixin':
                break;
            case 'broker':
            case 'ajlz':
            case 'anjuke':
                isFromApp = appValue;
                break;
            case 'wuba':
                isFromApp = 'wuba';
                break;
            default:
                isFromApp = '';
        }
        const site = host.indexOf('.58.') > -1 ? 'wuba' : 'anjuke';
        commit('updateRequest', {
            origin,
            cityId: _.get(cityV2, `${site}.id`),
            cityName: _.get(cityV2, `${site}.name`),
            cityAlias: _.get(cityV2, `${site}.alias`),
            isFromApp,
            ifFromWeApp: checkWeappByUserAgent(ua),
            ifFromMiniProgram: checkMiniProgramByUserAgent(ua),
            ifFromToutiaoProgram: checkToutiaoProgramByUserAgent(ua),
            appVersion: _.get(app, 'version'),
            appName: _.get(app, 'type'),
            guid,
            os: _.get(sourceH5, 'os') || '',
            seo_source_type: seoSourceType,
            source_h5: sourceH5,
            lon: _.get(location, 'lon'),
            lat: _.get(location, 'lat'),
            xxzlCid: req.headers['xxzl-cid'] || req.ctx.cookies.get('xxzl-cid') || '',
            ua
        });
    }
};
export const modules = {
    [createModule().moduleName]: {
        strict: false,
        ...createModule().moduleEntity
    }
};
